import { OverviewJobSectionEmptyState_organization$key } from '#app/__generated__/relay/OverviewJobSectionEmptyState_organization.graphql.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import EmptyStateImage from './assets/empty_state_lists.webp';
import {
  EmptyStateCard,
  Image,
  MessageContainer,
} from './EmptyState.styles.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';
import { useCallback } from 'react';

type OverviewUserListsSectionEmptyStateProps = {
  readonly organizationRef: OverviewJobSectionEmptyState_organization$key;
};

export const OverviewUserListsSectionEmptyState = ({
  organizationRef,
}: OverviewUserListsSectionEmptyStateProps) => {
  const { track } = useAnalytics();
  const organization =
    useFragment<OverviewJobSectionEmptyState_organization$key>(
      graphql`
        fragment OverviewUserListsSectionEmptyState_organization on Organization {
          visitorIsMember
        }
      `,
      organizationRef,
    );

  const handleClick = useCallback(() => {
    track('button', {
      action: 'tapped',
      button_name: 'company_profile_owner_empty_state_create_network_list',
    });
  }, [track]);

  const isMember = organization.visitorIsMember;

  if (!isMember) {
    return null;
  }

  return (
    <EmptyStateCard>
      <Image
        alt="Image of users lists with a 3D contra logo behind it"
        height={240}
        src={EmptyStateImage}
        width={320}
      />
      <MessageContainer>
        <Text
          as="h3"
          color="gray80"
          textStyle="subtitleRegular"
        >
          Your team hasn’t created any lists, yet!
        </Text>
        <Text
          color="gray70"
          textStyle="bodySmall"
        >
          Your teams lists will appear here to share your curated flexible
          talent network.
        </Text>
        <Button
          as={Link}
          onClick={handleClick}
          removeMinWidth
          size="small"
          to={getRoute('/network')}
          variant="V2Primary"
        >
          Create a list
        </Button>
      </MessageContainer>
    </EmptyStateCard>
  );
};
